import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { Row, Col, Card, Tabs, Tab } from 'react-bootstrap';
import CommonHeader from 'layouts/dashboard/CommonHeader';
import courseIcon from "../../assets/images/Courses.svg";
import { DocumentGenerationTable } from './document-generation-table';
import { VideoGenerationTable } from './video-generation-table';
import { PPTGenerationTable } from './ppt-generation-table';
import { ResourceGenerationTable } from './resource-table';
import { QAGenerationTable } from "./qna-generation-table";

const ContentGenerationDashboard = () => {
    const [cookies] = useCookies();
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.activeTab || 'resource');

    useEffect(() => {
        if (location.state?.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);
    const [documentCount, setDocumentCount] = useState(0);
    const [videoCount, setVideoCount] = useState(0);
    const [pptCount, setPPTCount] = useState(0);
    const [questionsCount, setQuestionsCount] = useState(0);
    const [resourcesCount, setResourcesCount] = useState(0);

    return (
        <div className="container-fluid">
            <Row>
                <Col>
                    <CommonHeader
                        text="Content Generation"
                        subText="Manage your generated content."
                        icon={courseIcon}
                    />
                </Col>
            </Row>

            <Row className="mx-auto">
                <Col sm={10} className="mx-auto pt-5 px-0">
                    <Card>
                        <Card.Body className="p-4 mb-2">
                            {/* Tabs */}
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(k) => setActiveTab(k)}
                                className="mb-3"
                                variant="pills"
                            >
                                <Tab eventKey="resource" title={`📚 Resources (${resourcesCount})`}>
                                <ResourceGenerationTable userId={cookies.userId} setResourceCount={setResourcesCount} />                                
                                </Tab> 
                                <Tab eventKey="documents" title={`📄 Documents (${documentCount})`}>
                                <DocumentGenerationTable userId={cookies.userId} setDocumentCount={setDocumentCount}/>
                                </Tab>

                                <Tab eventKey="videos" title={`🎥 Videos (${videoCount})`}>
                                    <VideoGenerationTable userId={cookies.userId} setVideoCount={setVideoCount}/>
                                </Tab>

                                <Tab eventKey="ppt" title={`📊 PPT (${pptCount})`}>
                                    <PPTGenerationTable userId={cookies.userId} setPPTCount={setPPTCount}/>
                                </Tab>


                                <Tab eventKey="qna" title={`❓ Q&A (${questionsCount})`}>
                                    <QAGenerationTable  userId={cookies.userId} setQuestionsCount={setQuestionsCount}/>
                                </Tab>
                            </Tabs>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default ContentGenerationDashboard;